import { useDepositAction } from '#/features/deposit/useDepositAction';

import { Button } from './atoms';

export default function DepositButton() {
  const depositAction = useDepositAction();

  return (
    <Button onClick={depositAction.execute} disabled={depositAction.isDisabled}>
      Deposit
    </Button>
  );
}
